export default __webpack_public_path__ + "media/14674549cd5c6802b445816b4b7e167cf593073d67be1283cfb15dcba97b3752.svg";